import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import CategoryLink from './CategoryLink';

// Presentational Component
class Sidebar extends React.PureComponent {
	render() {
		const { categories, selectedCategoryName } = this.props;
		return (
			<nav className="sidebar">
				<div className="scroll">

					{/* Links */}
					<h2>API Reference</h2>
					<div className="nav-links">
						{categories.map(category =>
							<CategoryLink key={category.name}
								category={category}
								isSelected={category.name === selectedCategoryName} />)}
					</div>

				</div>
			</nav>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	const { match } = ownProps;

	if (match) {
		const { category } = match.params;

		return {
			selectedCategoryName: category,
		};
	}

	return {};
};

Sidebar.propTypes = {
	categories: PropTypes.array.isRequired,
	selectedCategoryName: PropTypes.string,
	hash: PropTypes.string
};

export default withRouter(connect(mapStateToProps)(Sidebar));


// WEBPACK FOOTER //
// ./src/components/api/Sidebar.js